// Which locales each page is available in, and whether that translation is reviewed. Built by scripts/prerender.mjs
// and embedded in every page, so the language switcher and translation banner render the same on server and client.
import { createContext, useContext } from 'react'
import type { LocaleCode } from './locales'

export type Status = 'reviewed' | 'draft'
export type AltMap = Record<string, Partial<Record<LocaleCode, Status>>>
export const AltContext = createContext<AltMap>({})
export const useAlt = () => useContext(AltContext)
